var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71093 13.9723C11.3275 13.9723 14.2667 11.3869 14.2667 8.2056V0.516602H11.5351V8.2056C11.5351 10.0606 9.81971 11.5695 7.71093 11.5695C5.60215 11.5695 3.88672 10.0606 3.88672 8.2056V0.516602H1.15513V8.2056C1.15513 11.3869 4.09432 13.9723 7.71093 13.9723ZM0.0625 15.8946V17.8168H15.3594V15.8946H0.0625Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.cf1aa9f584150f802162017c31fde944.svg";
export { ForwardRef as ReactComponent };